export const authModuleIds = {
    SIGN_IN_WITH_PROVIDER_MODAL_MODULE: 'SIGN_IN_WITH_PROVIDER_MODAL_MODULE',
    TRANSFORM_TO_CREATOR: 'TRANSFORM_TO_CREATOR',
};
